import React, { useEffect } from 'react'
import { GridRowParams, GridRowSelectionModel } from '@mui/x-data-grid'
import { dashboard_columns, normalizeDashboardsForDataGrid } from '../../components/datagrid/gridData/dashboards'
import { useNavigate } from 'react-router-dom'
import { useOrganizationProvider } from '../../../providers/OrganizationProvider'
import { ROUTE_DASHBOARDS } from './DashboardsPage'
import { IDashboard } from '../../../domain/interfaces/IDashboard'
import { useDashboardPageViewModel } from './DashboardsPageViewModel'
import pluralize from 'pluralize'
// import { getAllNavDashboards } from '../../../data/data'
import BulkDeleteButton from '../../components/buttons/BulkButtons/BulkDeleteButton'
import { EdifyDataGrid } from '../../components/datagrid/EdifyDataGrid'
import { sortAllDashboardItems } from '../../../data/data'

interface IDashboardsDataGridProps {
  vm: any
  title: string
  checkboxSelection?: boolean
  error?: string
}

const DashboardsDataGrid: React.FC<IDashboardsDataGridProps> = ({ vm, title, checkboxSelection = true, error }) => {
  const [selectionModel, setSelectionModel] = React.useState<GridRowSelectionModel>([])
  const navigate = useNavigate()
  const { dashboards } = useDashboardPageViewModel()
  const { reloadDashboardLinks } = useOrganizationProvider()

  const handleRowClicked = (params: GridRowParams) => {
    navigate(`${ROUTE_DASHBOARDS}/${params.id}`, {
      state: { name: params.row.name },
    })
  }

  const updateFavoriteDashboardUI = async (id: string) => {
    const newDashboards = dashboards.map((d: IDashboard) => {
      if (d.id == id) {
        return { ...d, isFavorited: !d.isFavorited }
      }
      return d
    })
    reloadDashboardLinks()
    vm.setDashboards(sortAllDashboardItems(newDashboards))
    // setFavoritedDashboards(newDashboards)
  }

  const updateDefaultDashboardUI = async (id: string) => {
    const newDashboards = dashboards.map((d: IDashboard) => {
      return { ...d, isDefault: d.id == id, isFavorited: d.id == id ? true : d.isFavorited }
    })
    reloadDashboardLinks()
    vm.setDashboards(sortAllDashboardItems(newDashboards))
  }

  // delete dashboard/s
  const removeClicked = async () => {
    vm.showDeleteConfirmation(selectionModel as string[])
    setSelectionModel([])
  }

  const renderHeaderButtons = () => {
    if (!checkboxSelection) return <></>
    const noSelections = selectionModel.length === 0
    return <BulkDeleteButton noSelections={noSelections} onClick={removeClicked} />
  }

  const rows = normalizeDashboardsForDataGrid(
    [...dashboards],
    updateFavoriteDashboardUI,
    updateDefaultDashboardUI,
    navigate,
    vm.getFavoriteCount,
  )
  useEffect(() => {
    vm.setDashboards(sortAllDashboardItems(vm.dashboards))
  })

  return (
    <>
      <EdifyDataGrid
        data-testid='DashboardsDataGrid'
        noRowsText={`No ${pluralize(title)} found.`}
        title={title}
        columns={dashboard_columns}
        rows={rows}
        error={error || vm.error}
        rowSelectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        handleRowClicked={handleRowClicked}
        loading={vm.isLoading}
        rowCount={vm.totalCount || 0}
        loadMoreRows={vm.loadMore}
        reload={vm.loadDashboards}
        checkboxSelection={checkboxSelection}
        renderHeaderButtons={renderHeaderButtons()}
        sortClickedHandler={vm.sortClickedHandler}
        initSort={[
          {
            field: 'default',
            sort: 'asc',
          },
        ]}
      />
    </>
  )
}

export default DashboardsDataGrid
